/* The footer's language switch: the languages' names, dotted apart, in the
   footer's small muted text, the current one in ink. */
.switch {
  display: inline-flex;
  align-items: center;
  gap: var(--zumpo-space-8);
}

.language {
  position: relative;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: var(--zumpo-radius-8);
  background: none;
  color: var(--zumpo-muted);
  font: inherit;
  letter-spacing: inherit;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.language + .language::before {
  content: '·';
  margin-inline-end: var(--zumpo-space-8);
  color: var(--zumpo-muted);
}

/* Drawn as a line of small text, a language takes a tap from 44 px tall,
   the size a thumb needs, and 4 px either side of its name. */
.language::after {
  position: absolute;
  inset: calc(-1 * (var(--zumpo-space-12) + var(--zumpo-space-1)))
    calc(-1 * var(--zumpo-space-4));
  content: '';
}

.language[aria-checked='true'] {
  color: var(--zumpo-ink);
  font-weight: 700;
  cursor: default;
}

@media (hover: hover) {
  .language:hover {
    color: var(--zumpo-ink);
  }
}

.language:focus-visible {
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}
